import { render } from "./InputFile.vue?vue&type=template&id=2fbc57e4"
import script from "./InputFile.vue?vue&type=script&lang=ts"
export * from "./InputFile.vue?vue&type=script&lang=ts"
script.render = render

export default script